import { rufflePath } from "./shapes";

/*
 * Shared symbols and gradients for every drawing in the theme, rendered once at the
 * theme root. Drawings place them with <use href="#ut-…">, which keeps garlands of
 * hundreds of flowers light.
 */
const Defs = () => (
  <svg className="ut-defs" aria-hidden="true" focusable="false">
    <defs>
      {/* Marigold (genda): ruffled rings, deepening towards the centre */}
      <symbol id="ut-marigold" viewBox="-11 -11 22 22" overflow="visible">
        <path d={rufflePath(8.6, 14, 1.6)} fill="#ec7a0c" />
        <path d={rufflePath(6.6, 12, 1.4, 0.6)} fill="#f79a17" />
        <path d={rufflePath(4.4, 10, 1.1, 0.2)} fill="#fbb431" />
        <circle r="2.2" fill="#e5800d" />
        <circle r="1" fill="#b75606" />
      </symbol>
      <symbol id="ut-marigold-yellow" viewBox="-11 -11 22 22" overflow="visible">
        <path d={rufflePath(8.6, 14, 1.6)} fill="#f2b705" />
        <path d={rufflePath(6.6, 12, 1.4, 0.6)} fill="#ffcd2e" />
        <path d={rufflePath(4.4, 10, 1.1, 0.2)} fill="#ffdd5c" />
        <circle r="2.2" fill="#f0a500" />
        <circle r="1" fill="#c47f00" />
      </symbol>

      {/* Rose: a pink bloom with its petals spiralling in */}
      <symbol id="ut-rose" viewBox="-11 -11 22 22" overflow="visible">
        <circle r="9" fill="#e2457f" />
        <path d="M-6.5,1.5 C-6,-6 6,-7 6.8,0.5 C7,5.5 1,7.6 -2.4,5.6" fill="none" stroke="#b81d5a" strokeWidth="1.3" strokeLinecap="round" />
        <path d="M-3.6,0.8 C-3,-3.6 3.6,-3.8 3.8,0.4 C3.9,3 0.6,4 -1.2,2.8" fill="none" stroke="#a5154e" strokeWidth="1.2" strokeLinecap="round" />
        <path d="M-1,0.2 C-0.6,-1.4 1.4,-1.2 1.2,0.4" fill="none" stroke="#8f0f43" strokeWidth="1.1" strokeLinecap="round" />
        <ellipse cx="-3.6" cy="-4.6" rx="2.6" ry="1.2" fill="#f58db3" opacity="0.7" transform="rotate(-30 -3.6 -4.6)" />
      </symbol>

      {/* Mirror-work sequin: a tiny disc of glass in a gold rim */}
      <symbol id="ut-mirror" viewBox="-3 -3 6 6" overflow="visible">
        <circle r="2.4" fill="#f4d27a" />
        <circle r="1.6" fill="#fffdf6" />
      </symbol>

      <linearGradient id="ut-gold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#f6dc8a" />
        <stop offset="0.5" stopColor="#d7a63a" />
        <stop offset="1" stopColor="#a8761c" />
      </linearGradient>
      <linearGradient id="ut-gold-h" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#a8761c" />
        <stop offset="0.45" stopColor="#f6dc8a" />
        <stop offset="1" stopColor="#b5841f" />
      </linearGradient>
      <linearGradient id="ut-wood" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#7a4a22" />
        <stop offset="0.45" stopColor="#c08a4e" />
        <stop offset="1" stopColor="#6d3f1b" />
      </linearGradient>
      <radialGradient id="ut-sheen" cx="0.3" cy="0.2" r="0.8">
        <stop offset="0" stopColor="#fff" stopOpacity="0.55" />
        <stop offset="0.5" stopColor="#fff" stopOpacity="0.08" />
        <stop offset="1" stopColor="#000" stopOpacity="0.18" />
      </radialGradient>

      {/* ---- The gate (art/Gate.js) ---- */}
      {/* Jaipur pink plaster, lit from above */}
      <linearGradient id="ut-pink-stone" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e27f9b" />
        <stop offset="0.55" stopColor="#d6607f" />
        <stop offset="1" stopColor="#c44b6c" />
      </linearGradient>
      {/* Painted peacock-teal door wood, and the deeper teal of its recessed panels */}
      <linearGradient id="ut-door-teal" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#0a5258" />
        <stop offset="0.45" stopColor="#14868b" />
        <stop offset="1" stopColor="#0b5c62" />
      </linearGradient>
      <linearGradient id="ut-door-panel" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#0c6066" />
        <stop offset="1" stopColor="#084a50" />
      </linearGradient>
      {/* The step */}
      <linearGradient id="ut-haldi" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#fbd970" />
        <stop offset="1" stopColor="#eeac25" />
      </linearGradient>
      {/* Brass, for the finial */}
      <radialGradient id="ut-brass" cx="0.36" cy="0.3" r="0.75">
        <stop offset="0" stopColor="#fff4cc" />
        <stop offset="0.3" stopColor="#ecc978" />
        <stop offset="0.65" stopColor="#c9962b" />
        <stop offset="1" stopColor="#7c5410" />
      </radialGradient>
    </defs>
  </svg>
);

export default Defs;
